import { render, staticRenderFns } from "./TintometricoBase.vue?vue&type=template&id=3db425b0"
import script from "./TintometricoBase.vue?vue&type=script&lang=js"
export * from "./TintometricoBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports